import { Item, MenuItem } from "../../components/Menu";
import { UISelectors, UserContextSelectors } from "../../redux/selectors";
import React from "react";
import { UrlUtils } from "../../utils";
import { useCommunicationHandlers } from "../UsefulLinks";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { Brand } from "../../../src/configurations/index";
import { LocalizationMessages } from "../../localization/messages";
import { AppFeatures } from "../../constants/featureFlags";
import { useFeature } from "../../hooks/useFeature";

const LiveChatMenuItem = () => {
  const isCustomerRelationsActive = useFeature(AppFeatures.CUSTOMER_RELATIONS);
  const { handleChatClick } = useCommunicationHandlers();
  const { locale } = useIntl();
  const links = useSelector(UISelectors.links);
  const cid = useSelector(UserContextSelectors.cid);
  const isVip = useSelector(UserContextSelectors.isVip);
  const brandId = useSelector(UserContextSelectors.brandId);

  const getLink = brandId => {
    let link;
    if (brandId === Brand.Sport_Com && locale !== "en") {
      link = links.liveChatDE;
    } else if (isVip) {
      link = links.liveChatVIP;
    } else {
      link = links.liveChat;
    }
    return link;
  };

  const liveChatItem = new Item({
    URL: !isCustomerRelationsActive
      ? `${UrlUtils.getNativeLink(getLink(brandId))}&cid=${cid}`
      : undefined,
    title: LocalizationMessages.liveChat,
    iconKey: "chat",
    target: "ChatTab"
  });

  return (
    <MenuItem
      item={liveChatItem}
      dataTestId="uc-live-chat"
      ignoreNavigation={true}
      onClick={isCustomerRelationsActive ? handleChatClick : undefined}
    />
  );
};

export default LiveChatMenuItem;
